<div class="td-wb-modal-notification"
     [ngClass]="{
      'td-wb-modal-notification-responsive-view': isResponsiveView(),
      'td-wb-modal-notification-responsive-view--whats-new': isResponsiveView() && hasWhatsNewModalFeatureFlag
     }"
     [attr.data-td-wb-help-context-id]="'td-wb-modal-notification-' + triggerId">
  <td-wb-modal-header [iconId]="getIconId()">
    <td-wb-modal-header-title [modalTitle]="getModalNotificationTitle()">
    </td-wb-modal-header-title>
    <td-wb-modal-header-buttons>
      <td-wb-modal-close-button></td-wb-modal-close-button>
    </td-wb-modal-header-buttons>
  </td-wb-modal-header>

  @if (hasContent()) {
    <td-wb-include
      [ngClass]="{ 'td-wb-modal-notification-responsive-view-content': isResponsiveView() }"
      [linkId]="getCurrentPageLinkId()">
    </td-wb-include>
  }

  @if (shouldShowPagination() || !isResponsiveView()) {
    <td-wb-form-footer class="td-wb-modal-notification--footer">
      @if (hasWhatsNewModalFeatureFlag) {
        <ng-container *ngTemplateOutlet="paginationTemplate"></ng-container>
        @if (shouldShowButtons() && !isResponsiveView()) {
          <ng-container *ngTemplateOutlet="multiTemplate"></ng-container>
        }
      } @else {
          @if (shouldShowButtons() && !isResponsiveView()) {
            <ng-container *ngTemplateOutlet="footerStartTemplate"></ng-container>
          }
          @if (shouldShowPagination()) {
            <ng-container *ngTemplateOutlet="paginationTemplate"></ng-container>
          }
          @if (shouldShowButtons() && !isResponsiveView()) {
           <ng-container *ngTemplateOutlet="footerEndTemplate"></ng-container>
          }
        }
      </td-wb-form-footer>
  }
  @if (shouldShowButtons() && isResponsiveView()) {
    @if (hasWhatsNewModalFeatureFlag) {
      <div class="td-wb-modal-notification__responsive-footer">
        <ng-container *ngTemplateOutlet="multiTemplate"></ng-container>
      </div>
    } @else {
      <div class="td-wb-modal-notification__responsive-footer">
        <ng-container *ngTemplateOutlet="footerStartTemplate"></ng-container>
        <ng-container *ngTemplateOutlet="footerEndTemplate"></ng-container>
      </div>
    }
  }
</div>

<ng-template #footerStartTemplate>
  <div class="td-wb-modal-notification__footer-start">
    @for (button of triggerContent.buttons.left; track button) {
      @if (button.linkId !== '#') {
        <ng-container *ngTemplateOutlet="buttonTemplate; context:{ button: button, class: '-start' }"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="closeButtonTemplate; context:{ button: button }"></ng-container>
      }
    }
  </div>
</ng-template>

<ng-template #footerEndTemplate>
  <div class="td-wb-modal-notification__footer-end">
    @for (button of triggerContent.buttons.right; track button) {
      @if (button.linkId !== '#') {
        <ng-container *ngTemplateOutlet="buttonTemplate; context:{ button: button, class: '-end' }"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="closeButtonTemplate; context:{ button: button }"></ng-container>
      }
    }
  </div>
</ng-template>

<ng-template #multiTemplate>
  <div class="td-wb-modal-notification__footer-end">
    <ng-container *ngTemplateOutlet="doneButtonTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #paginationTemplate>
  @if (shouldShowPagination()) {
    <div class="td-wb-modal-notification__pagination">
      <td-wb-pagination [selectedPage]="currentPage"
                        [itemCount]="hasWhatsNewModalFeatureFlag ? subModals.length : triggerContent.contentURLs.length"
                        [itemsPerPage]="1"
                        (selectedPageChange)="pageChange($event)">
      </td-wb-pagination>
    </div>
  }
</ng-template>

<ng-template #doneButtonTemplate>
  <button id="td-wb-modal-notification-button--done"
          class="td-wb-modal-notification__button"
          tdWbButton
          tdWbButtonType="primary"
          tdWbModalClose>
    <span translate="tdWb.modalNotification.DONE"></span>
  </button>
</ng-template>

<ng-template #buttonTemplate let-button="button" let-class="class">
  <button [id]="'td-wb-modal-notification-button-' + button.id"
          [class]="'td-wb-modal-notification__button' + class"
          [tdWbHref]="button.linkId"
          tdWbButton
          [tdWbButtonType]="button.type">
    <span [innerHtml]="button.text"></span>
  </button>
</ng-template>

<ng-template #closeButtonTemplate let-button="button" let-class="class">
  <button [id]="'td-wb-modal-notification-button-' + button.id"
          [class]="'td-wb-modal-notification__button' + class"
          tdWbButton
          [tdWbButtonType]="button.type"
          tdWbModalClose>
    <span [innerHtml]="button.text"></span>
  </button>
</ng-template>
